

const area: { [key: string]: string } = {
    "Forest": "#048605",
    "Death Mountain": "#b53336",
    "Kakariko": "#c479c8",
    "Zora": "#5181fe",
    "Desert": "#e5ad08",
    "Hyrule": "#23b4a6"
}

export function getColorArea(areaName: string) {


    return area[areaName];
}